export default "__VITE_ASSET__BZA4Lb4I__"